<template>
  <div>
    <main-layout>
      <v-container>
        <h3 class="headline">{{ $t('Notification Setting') }}</h3>
        <v-layout row wrap class="mb-5">
          <!-- Setting 1 -->
          <v-flex xs12 sm12 style="padding: 24px 0">
            <label class="toggle-switch small my-3" style="vertical-align: middle">
              <input type="checkbox" :checked="setting_1" @change="toggleSetting1()" />
              <span class="toggle-slider lever round"></span>
            </label>
            <span class="pl-4 py-2"
              >1. แสดง Notification เมื่อมี chat ถูกผลักจาก bot มาให้ agent</span
            >
          </v-flex>
          <!-- Setting 2 -->
          <v-flex xs12 sm12 style="padding: 24px 0">
            <div>
              <label class="toggle-switch small my-3" style="vertical-align: middle">
                <input type="checkbox" :checked="setting_2" @change="toggleSetting2()" />
                <span class="toggle-slider lever round"></span>
              </label>
              <span class="pl-4 py-2"
                >2. แสดง Notification เมื่อ client ส่งข้อความใหม่เข้ามาและอยู่ในขณะที่ agent
                เป็นผู้ดูแลการสนทนา
              </span>
              <div style="float: right">
                <v-btn outline fab small color="primary" class="ma-0" @click="isEdit = true">
                  <v-icon>edit</v-icon>
                </v-btn>
              </div>
            </div>
            <div>
              <div>สีแจ้งเตือน</div>
              <div class="wheel" id="colorWheel"></div>
              <v-color-picker class="ma-2" show-swatches></v-color-picker>
            </div>
          </v-flex>
          <!-- Setting 3 -->
          <v-flex xs12 sm12 style="padding: 24px 0">
            <label class="toggle-switch small my-3" style="vertical-align: middle">
              <input type="checkbox" :checked="setting_3" @change="toggleSetting2()" />
              <span class="toggle-slider lever round"></span>
            </label>
            <span class="pl-4 py-2"
              >3.แสดง Notification เมื่อไม่มีการ respond หลังจาก client ส่งข้อความมาแล้ว xx
              นาที</span
            >
            <div style="float: right">
              <v-btn outline fab small color="primary" class="ma-0" @click="isEdit = true">
                <v-icon>edit</v-icon>
              </v-btn>
            </div>
          </v-flex>
          <!-- Setting 4 -->
          <v-flex xs12 sm12 style="padding: 24px 0">
            <label class="toggle-switch small my-3" style="vertical-align: middle">
              <input type="checkbox" :checked="setting_4" @change="toggleSetting2()" />
              <span class="toggle-slider lever round"></span>
            </label>
            <span class="pl-4 py-2">
              4.แสดง Notification เมื่อ agent อ่านข้อความ แล้ว xx นาที และไม่มีการ respond หรือปิด
              case
            </span>
            <div style="float: right">
              <v-btn outline fab small color="primary" class="ma-0" @click="isEdit = true">
                <v-icon>edit</v-icon>
              </v-btn>
            </div>
          </v-flex>
          <!-- Setting 5 -->
          <v-flex xs12 sm12 style="padding: 24px 0">
            <label class="toggle-switch small my-3" style="vertical-align: middle">
              <input type="checkbox" :checked="setting_5" @change="toggleSetting2()" />
              <span class="toggle-slider lever round"></span>
            </label>
            <span class="pl-4 py-2"
              >5. แสดง Notification เมื่อ client ไม่ respond หลังอ่านข้อความที่ตอบกลับไปแล้ว xx
              นาที</span
            >
            <div style="float: right">
              <v-btn outline fab small color="primary" class="ma-0" @click="isEdit = true">
                <v-icon>edit</v-icon>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </main-layout>
  </div>
</template>

<script>
import iro from '@jaames/iro'
export default {
  components: {},
  data() {
    return {
      setting_1: false,
      setting_2: false,
      setting_3: false,
      setting_4: false,
      setting_5: false,
      isEdit: false,
      colorWheel: ''
    }
  },
  mounted() {
    this.colorWheel = new iro.ColorPicker('#colorWheel', {
      width: 200,
      height: 150,
      color: 'rgb(255, 255, 255)',
      borderWidth: 1,
      borderColor: '#fff'
    })
    this.colorWheel.on(['color:init', 'color:change'], function (color) {
      vm.input.background = color.hexString
    })
  },
  methods: {
    toggleSetting1: function () {
      // let vm = this
      // let bot = Object.assign({}, vm.selectedBot)
      // bot.status = !bot.status
      // let data = {
      //   theme: bot.theme,
      //   page_access_token: bot.page_access_token,
      //   pageid: bot.pageid,
      //   status: bot.status
      // }
      // vm.$store.dispatch('loading')
      // api.toggleBotStatus(data, function(error, response) {
      //   if (error) {
      //     console.error(error)
      //     vm.$store.dispatch('loading')
      //     return
      //   }
      //   let newbotlist = vm.botlist
      //   $.each(newbotlist, function(index, oldbot) {
      //     if (bot.pageid === oldbot.pageid) {
      //       newbotlist[index].status = bot.status
      //       return false
      //     }
      //   })
      //   // console.log(bot)
      //   vm.botStatus = bot.status
      //   vm.$store.dispatch('selectBot', bot)
      //   vm.$store.dispatch('updateBotlist', newbotlist)
      //   vm.$store.dispatch('loading')
      // })
    }
  },
  watch: {
    dialogopen(val, oldval) {
      this.input = { ...this.inputx }
      this.colorWheel.color.hexString = this.inputx.background
      this.$nextTick(() => {
        this.errors.clear()
        this.$nextTick(() => {
          this.$validator.reset()
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/tdtawandang/notificationsetting/main.vue